export class Firebase {}

export class FirebaseInsertToken {
    token: string;
    deviceType: string = "web";
    deviceId: string;
    timestamp: string;
}

export enum AllAndMyTasksToggleValuesEnum {
    ALL,
    MY
}